<template>
    <div>
        <div class="search-banner d-none d-lg-block d-xl-block">
            <div class="container-src">
                <desktop-form
                    :dropdowns="data.dropdowns"
                    :currentsearch="data.currentSearch"
                    :colors="colors"
                    @submitsearch="submit"
                    @comunechanged="cambioComune"
                    @tipologiachanged="cambioTipologia"
                    @aziendachanged="cambioAzienda"
                    :isLoading="isLoading"
                    :isMobile="false"
                ></desktop-form>
            </div>
        </div>
        <div class="d-lg-none d-xl-none">
            <mobile-form
                :dropdowns="data.dropdowns"
                :currentsearch="data.currentSearch"
                :colors="colors"
                @submitsearch="submit"
                @comunechanged="cambioComune"
                @tipologiachanged="cambioTipologia"
                @aziendachanged="cambioAzienda"
                :isLoading="isLoading"
                :isMobile="true"
            ></mobile-form>
        </div>
    </div>
</template>

<script>
    import DesktopForm from './AziendeDesktopSearchForm.vue';
    import MobileForm from './AziendeMobileSearchForm.vue';

    export default {
        props: ['dropdowns', 'currentsearch', 'colors'],
        components: {
            'desktop-form': DesktopForm,
            'mobile-form': MobileForm
        },
        data() {
            return {
                isLoading: false,
                data: {
                    dropdowns: {
                        comuni: [],
                        aziende: [],
                        tipiAzienda: []
                    },
                    currentSearch: {
                        tipologia: null,
                        citta: null,
                        azienda: null
                    }
                }
            }
        },
        methods: {
            submit() {
                this.isLoading = true;
                window.axios.post(window.base_url + 'aziende/search-path', this.getPayload())
                .then((res) => {
                    window.location.href = res.data.data.path;
                })
                .catch((err) => {
                    this.isLoading = false;
                    Swal.fire({
                        text: 'Qualcosa è andato storto, prova di nuovo.',
                        type: 'error',
                        showConfirmButton: false
                    });
                });
            },
            aggiornaDropdown() {
                return window.axios.post(window.base_url + 'aziende/dropdowns', this.getPayload());
            },
            cambioComune(event) {
                // Aggiorno il comune
                this.data.currentSearch.citta = event;
                // Inizio a caricare
                this.isLoading = true;
                // Aggiorno le dropdown
                this.aggiornaDropdown()
                .then((res) => {
                    // Azzero l'azienda
                    this.data.currentSearch.azienda = null;
                    // Ripopolo le dropdown
                    this.data.dropdowns.aziende = res.data.data.aziende;
                    // Finisco di caricare
                    this.isLoading = false;
                })
                .catch((err) => {
                    this.isLoading = false;
                    Swal.fire({
                        text: 'Qualcosa è andato storto, prova di nuovo.',
                        type: 'error',
                        showConfirmButton: false
                    });
                });
            },
            cambioTipologia(event) {
                // Aggiorno la tipologia
                this.data.currentSearch.tipologia = event;
                // Inizio a caricare
                this.isLoading = true;
                // Aggiorno le dropdown
                this.aggiornaDropdown()
                .then((res) => {
                    // Azzero l'azienda
                    this.data.currentSearch.azienda = null;
                    // Ripopolo le dropdown
                    this.data.dropdowns.aziende = res.data.data.aziende;
                    // Azzero il comune
                    this.data.currentSearch.citta = null;
                    // Ripopolo le dropdown
                    this.data.dropdowns.comuni = res.data.data.comuni;
                    // Finisco di caricare
                    this.isLoading = false;
                })
                .catch((err) => {
                    this.isLoading = false;
                    Swal.fire({
                        text: 'Qualcosa è andato storto, prova di nuovo.',
                        type: 'error',
                        showConfirmButton: false
                    });
                });
            },
            cambioAzienda(event) {
                // Aggiorno l'azienda
                this.data.currentSearch.azienda = event;
            },
            getPayload() {
                return {
                    type_id: this.data.currentSearch.tipologia ? this.data.currentSearch.tipologia.id : null,
                    citta_id: this.data.currentSearch.citta ? this.data.currentSearch.citta.id : null,
                    azienda_id: this.data.currentSearch.azienda ? this.data.currentSearch.azienda.id : null
                }
            }
        },
        mounted() {
            this.data.dropdowns = this.dropdowns;
            this.data.currentSearch = this.currentsearch;
        }
    }
</script>
